import {
    type FC,
    useContext,
    useEffect,
    useState,
} from "react";
import FontAwesomeLight from "../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import Media from "../../../Media/Media";
import { isReceiptLogoComponentValue } from "../ReceiptLogoComponent";

export const ReceiptLogoSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const [ width, setWidth ] = useState(0);

    let fallback: string | null = null;

    if(isReceiptLogoComponentValue(value)) {
        fallback = value.fallback;
    }

    useEffect(() => {
        if(typeof fallback !== "string") {
            return;
        }

        const img = document.createElement("img");

        img.src = fallback;

        const listener = () => {
            setWidth(img.width);
        };

        img.addEventListener("load", listener);

        return () => {
            img.removeEventListener("load", listener);
            img.remove();
        };
    }, [ fallback ]);

    return (
        <>
            <label className="block">
                Fallback
                <Media
                    type="image"
                    noSource={(
                        <div className="flex p-4 flex-col justify-center items-center">
                            <div className="text-4xl text-neutral-400 dark:text-neutral-500">
                                <FontAwesomeLight icon="image" />
                            </div>
                            <div className="text-neutral-600 dark:text-neutral-400">Select to Add Image</div>
                        </div>
                    )}
                    removable
                    source={fallback || undefined}
                    onChange={(fallback) => {
                        manager.updateComponent(id, {
                            ...(isReceiptLogoComponentValue(value) ? value : {}),
                            fallback,
                        });
                    }}
                    onRemove={() => {
                        manager.updateComponent(id, {
                            ...(isReceiptLogoComponentValue(value) ? value : {}),
                            fallback: null,
                        });
                    }}
                />
            </label>
            {width > 600 && (
                <p className="p-2 bg-orange-300">
                    The fallback image selected is larger than 600px wide, some
                    email clients such as Microsoft Outlook may display this incorrectly
                </p>
            )}
        </>
    );
};
